export default {
  methods: {
    resolveAndFollow: function (router, routeDescription, openNewTab) {
      if (openNewTab) {
        let routeData = this.$router.resolve(routeDescription);
        window.open(routeData.href);
      } else {
        router.push(routeDescription);
      }
    },
    resolveAndFollowWMouseEvent(router, routeDescription, mouseEvent) {
      let openNewTab =
        mouseEvent.originalEvent.ctrlKey ||
        mouseEvent.originalEvent.metaKey ||
        mouseEvent.originalEvent.type === 'auxclick';
      this.resolveAndFollow(router, routeDescription, openNewTab);
    },
    openInBlankWindow(url) {
      const win = window.open(url, '_blank');
      win.focus();
    },
  },
};
